import { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import DropdownButton from '../../../molecules/dropdown-button'
import { LinkList } from '../types'
import { Text } from '../../../atoms/text'
import { Button } from '../../../atoms/button'
import { Link } from 'gatsby'

const DesktopLinkLists: FunctionComponent<{ linkLists: LinkList[] }> = ({ linkLists }) => {
  return (
    <GridContainer>
      {linkLists.map(linkList => {
        const titleId = `footer-nav-${linkList.title.toLowerCase().replace(/\s+/g, '-')}`
        return (
          <ListItem key={linkList.title}>
            <nav aria-labelledby={titleId}>
              <DropdownButton
                trigger={({ open }) => (
                  <PopoverItemButton
                    as="div"
                    variant="ghost"
                    themeOverride="background_is_lighter"
                    trailingIcon={open ? 'chevron-up' : 'chevron-down'}
                    gap="full"
                  >
                    <LinkListTitle as="h2" fontStyle="label-l" id={titleId}>
                      {linkList.title}
                    </LinkListTitle>
                  </PopoverItemButton>
                )}
              >
                <LinkItemsList>
                  {linkList.links.map((link, index) => (
                    <li key={`${link.title}-${index}`}>
                      <LinkListItem
                        variant="ghost"
                        themeOverride="background_is_lighter"
                        as={link.openInNewTab ? 'a' : Link}
                        {...(link.openInNewTab ? { href: `${link.link}` } : { to: `${link.link}` })}
                        target={link.openInNewTab ? '_blank' : '_self'}
                        rel={link.openInNewTab ? 'noopener noreferrer' : undefined}
                      >
                        <Text fontStyle="label-m" as="span">
                          {link.title}
                        </Text>
                      </LinkListItem>
                    </li>
                  ))}
                </LinkItemsList>
              </DropdownButton>
            </nav>
          </ListItem>
        )
      })}
    </GridContainer>
  )
}

const GridContainer = styled.div`
  grid-area: linkList;
  display: grid;
  grid-template-rows: repeat(2, auto);
  border-bottom: var(--neutral-700) 1px solid;
  list-style: none;
`

const LinkListTitle = styled(Text)`
  text-transform: uppercase;
  color: var(--beige-300);
  white-space: nowrap;
`

const ListItem = styled.div``

const PopoverItemButton = styled(Button)`
  border-top: var(--neutral-700) 1px solid;
  padding-inline: 0;
`

const LinkItemsList = styled.ul`
  margin-bottom: 1.25rem;

  list-style: none;
  display: grid;
  gap: 1.25rem;
  color: var(--beige-250);
`

const LinkListItem = styled(Button)`
  width: fit-content;
  padding: 0;
  text-align: left;
  text-transform: none;
  color: var(--beige-250);
  &:hover {
    color: var(--beige-200);
  }
`

export default DesktopLinkLists
